import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const authService = {
  signup: async (email, name, password, companyName, industry, phone) => {
    const response = await axios.post(`${API}/auth/signup`, { 
      email, 
      name, 
      password,
      company_name: companyName,
      industry,
      phone
    });
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  login: async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  googleCallback: async (sessionId) => {
    const response = await axios.post(`${API}/auth/google/callback`, { 
      session_id: sessionId 
    }, {
      withCredentials: true
    });
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  verifyOtp: async (verificationId, otp, isSignup, signupData) => {
    const response = await axios.post(`${API}/auth/verify-otp`, {
      verification_id: verificationId,
      otp,
      is_signup: isSignup,
      signup_data: signupData
    });
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  resendOtp: async (email) => {
    const response = await axios.post(`${API}/auth/resend-otp`, { email });
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
};

export const getAuthHeaders = () => {
  const token = authService.getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};
